import React from 'react';
import { UpsellTitles, ServiceTitles } from 'models/backend/constant/Upsell';
import { DynamicTypography, LateCheckOutCard, AlarmClockCard, ThreeStateButton, RoomControlCard} from 'components';
import { getVerbiage } from 'utils/stringHelper';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/state';

interface IProps  {
  title: string;
  onSetMessage: (message: string) => void;
  onCompleted: (isCompleted: boolean) => void;
};

export const ServiceRequestCard: React.FC<IProps> = ({ title, onSetMessage, onCompleted}) => {
    const [charge, setCharge] = React.useState('');
    const handleChargeUpdate = (newCharge:string) =>{
        setCharge(newCharge);
    };
    const { verbiages } = useSelector((state: RootState) => state.verbiages);

    const handleCompleteSetAlarm = (isCompleted: boolean) =>{
        onCompleted(isCompleted);
        if(isCompleted){
            onSetMessage("Your alarm is set!");
        }
        else{
            onSetMessage("");
        }
    };

    const handleCompleteRoomControlSetting = (isCompleted: boolean) =>{
        onCompleted(isCompleted);
        if(isCompleted){            
            onSetMessage("Your room control mode is set!");
        }
        else{
            onSetMessage("");
        }
    };

    const handleCompleteHouseKeepingSetting = (isCompleted: boolean) => {
        onCompleted(isCompleted);
        if(isCompleted){
            onSetMessage("Your housekeeping mode is set!");
        }
        else{
            onSetMessage("");
        }
    };

    React.useEffect(() => {
        onCompleted(charge != '');
        if(charge!= ''){
            onSetMessage("Check-out time set successfully!");
        }
        else{
            onSetMessage("");
        }
    }, [charge]);
    
    return (    
        title===UpsellTitles.LateCheckOut ? (
            <div>
                <div style={{ display: 'flex', padding: '3px', justifyContent: 'center', alignItems: 'center' }}>
                    <DynamicTypography
                        color="textPrimary"
                        align="center"
                        variant="h6"
                        style={{fontWeight: 'bold'}}
                        content={`${getVerbiage(
                            verbiages,
                            'weblbl100'
                        )}`}
                    ></DynamicTypography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                    <LateCheckOutCard onChargeUpdate={handleChargeUpdate}/>
                </div>
            </div>
            
        ): title===ServiceTitles.MorningCall ? (
            <>
                <div style={{ display: 'flex', padding: '3px', justifyContent: 'center', alignItems: 'center'}}>
                    <DynamicTypography
                            color="textPrimary"
                            align="center"
                            variant="h6"                        
                            style={{fontWeight: 'bold'}}
                            content={`${getVerbiage(
                                verbiages,
                                'weblbl101'
                            )}`}
                    ></DynamicTypography>
                </div>
                <AlarmClockCard onCompleted={handleCompleteSetAlarm}/> 
            </>
        ): title===ServiceTitles.Housekeeping ? (
            <>
                <div style={{ display: 'flex', padding: '3px', justifyContent: 'center', alignItems: 'center'}}>
                    <DynamicTypography
                            color="textPrimary"
                            align="center"
                            variant="h6"
                            style={{fontWeight: 'bold'}}
                            content={`${getVerbiage(
                                verbiages,
                                'weblbl102'
                            )}`}
                    ></DynamicTypography>
                </div>
                <ThreeStateButton onCompleted={handleCompleteHouseKeepingSetting}/>
            </>
        ): title===ServiceTitles.RoomControl ? (
            <>
                <div style={{ display: 'flex', padding: '3px', justifyContent: 'center', alignItems: 'center'}}>
                    <DynamicTypography
                                color="textPrimary"
                                align="center"
                                variant="h6"
                                style={{fontWeight: 'bold'}}
                                content={`${getVerbiage(
                                    verbiages,
                                    'weblbl103'
                                )}`}
                    ></DynamicTypography>
                </div>
                <RoomControlCard onCompleted={handleCompleteRoomControlSetting}/>
            </>
        ):
        null
    );
};
